import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import CoachView from 'views/coach';


export default Backbone.View.extend({
  initialize: function (options) {
    _.bindAll(this, 'render', 'rerender_coaches');

    this.template = _.template($('#coach-list-tmpl').html());
    this.coachhub = options.coachhub;

    this.render();
  },
  render: function () {
    this.$el.html(this.template({ coaches: this.collection }));
    this.collection.each(function (coach) {
      new CoachView({
        model: coach,
        coachhub: this.coachhub,
        el: $('#coach-' + coach.get('user').id, this.$el)
      });
    }, this);
  },
  rerender_coaches: function (params) {
    // Record the params we are filtering with. data('params') will always have the most recent params
    this.$el.data('params', $.param(params, true));
    var that = this;
    // Only rerender if the params match the most recent
    $.when(this.collection.fetch({ data: $.param(params, true) }))
      .then(function () { if (that.$el.data('params') == $.param(params, true)) { that.render(); } });
  }
});



// WEBPACK FOOTER //
// ./static/js/views/coach_list.js